import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import './Legal.css';

const Voorwaarden = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0
    }
  };

  return (
    <div className="legal-page">
      <SEO 
        title={t('terms.seo_title', 'Algemene Voorwaarden')}
        description={t('terms.seo_desc', 'Onze algemene voorwaarden en leveringscondities.')}
        canonical="/voorwaarden"
      />

      <section className="legal-hero">
        <div className="container">
          <motion.div 
            className="legal-header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>{t('terms.title', 'Algemene Voorwaarden')}</h1>
            <p className="last-updated">{t('terms.last_updated', 'Laatst bijgewerkt: 01/01/2024')}</p>
          </motion.div>
        </div>
      </section>

      <section className="legal-content section">
        <div className="container">
          <motion.div 
            className="legal-content-wrapper"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.div className="legal-section" variants={itemVariants}>
              <h2>1. {t('terms.definitions_title', 'Definities')}</h2>
              <p>{t('terms.definitions_text', 'In deze algemene voorwaarden wordt verstaan onder Luscious: de gebruiker van deze algemene voorwaarden; Opdrachtgever: de wederpartij van Luscious.')}</p>
            </motion.div>

            <motion.div className="legal-section" variants={itemVariants}>
              <h2>2. {t('terms.applicability_title', 'Toepasselijkheid')}</h2>
              <p>{t('terms.applicability_text', 'Deze voorwaarden zijn van toepassing op alle offertes, aanbiedingen, werkzaamheden, bestellingen, overeenkomsten en leveringen van diensten of producten door of namens Luscious.')}</p>
            </motion.div>

            <motion.div className="legal-section" variants={itemVariants}>
              <h2>3. {t('terms.offers_title', 'Offertes')}</h2>
              <p>{t('terms.offers_text', 'De door Luscious gemaakte offertes zijn vrijblijvend; zij zijn geldig gedurende 30 dagen, tenzij anders aangegeven.')}</p>
            </motion.div>

            <motion.div className="legal-section" variants={itemVariants}>
              <h2>4. {t('terms.execution_title', 'Uitvoering van de overeenkomst')}</h2>
              <p>{t('terms.execution_text', 'Luscious zal de overeenkomst naar beste inzicht en vermogen en overeenkomstig de eisen van goed vakmanschap uitvoeren.')}</p>
            </motion.div>

            <motion.div className="legal-section" variants={itemVariants}>
              <h2>5. {t('terms.changes_title', 'Wijziging van de overeenkomst')}</h2>
              <p>{t('terms.changes_text', 'Indien tijdens de uitvoering van de overeenkomst blijkt dat het voor een behoorlijke uitvoering noodzakelijk is om de te verrichten werkzaamheden te wijzigen of aan te vullen, zullen partijen tijdig en in onderling overleg de overeenkomst aanpassen.')}</p>
            </motion.div>

             <motion.div className="legal-section" variants={itemVariants}>
              <h2>6. {t('terms.payment_title', 'Betaling')}</h2>
              <p>{t('terms.payment_text', 'Betaling dient te geschieden binnen 14 dagen na factuurdatum, op een door Luscious aan te geven wijze in de valuta waarin is gefactureerd.')}</p>
            </motion.div>
            
            <motion.div className="legal-section" variants={itemVariants}>
              <h2>7. {t('terms.liability_title', 'Aansprakelijkheid')}</h2>
              <p>{t('terms.liability_text', 'Luscious is niet aansprakelijk voor schade, van welke aard ook, ontstaan doordat Luscious is uitgegaan van door of namens de opdrachtgever verstrekte onjuiste en/of onvolledige gegevens.')}</p>
            </motion.div>

            <motion.div className="legal-section" variants={itemVariants}>
              <h2>8. {t('terms.intellectual_property_title', 'Intellectuele eigendom')}</h2>
              <p>{t('terms.intellectual_property_text', 'Luscious behoudt zich de rechten en bevoegdheden voor die haar toekomen op grond van de Auteurswet en andere intellectuele wet- en regelgeving.')}</p>
            </motion.div>

            <motion.div className="legal-section" variants={itemVariants}>
              <h2>9. {t('terms.disputes_title', 'Geschillen')}</h2>
              <p>{t('terms.disputes_text', 'Op elke overeenkomst tussen Luscious en de Opdrachtgever is Belgisch recht van toepassing.')}</p>
            </motion.div>

            <motion.div className="legal-contact" variants={itemVariants}>
              <h3>{t('terms.contact_title', 'Vragen over onze voorwaarden?')}</h3>
              <p>{t('terms.contact_text', 'Neem contact met ons op via')} <a href="mailto:info@Luscious.be">info@Luscious.be</a>.</p>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Voorwaarden;
